import { useContext } from "react";
import { MainMenuContext } from "../context";
var useMainMenuContext = function useMainMenuContext() {
  var context = useContext(MainMenuContext);
  if (!context) {
    throw new Error('useMainMenuContext must be used within a MainMenuProvider');
  }
  return context;
};
export default useMainMenuContext;